module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noLoadingInformation":"There is no loading information yet."},"no":{"noLoadingInformation":"Det er ingen lasteopplysninger ennå."}}')
  delete Component.options._Ctor
}
